"use strict";

/**
 * @namespace
 */
gc.gis.control = gc.gis.control || {};

/**
 * Abstrakte Basisklasse für Map-Controls.
 *
 * @class
 * @abstract
 * @extends gc.gis.GCWrappable
 * @memberof gc.gis.control
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.map.GCMapView} options.map zu verwendende Karteninstanz
 * @param {string} options.target HTML-ID des Zielkontainers
 * @param {string} [options.id] Zu vergebende HTML-ID
 * @param {string} [options.className] Optionale CSS-Klasse(n)
 */
gc.gis.control.GCAbstractMapControl = function( options )
{
	gc.gis.GCWrappable.call( this );

	/**
	 * @protected
	 * @type jQuery|Vue
	 */
	this._element = undefined;
	/**
	 * @protected
	 * @type gc.gis.map.GCMapView
	 */
	this._map     = options.map;
	/**
	 * @protected
	 * @type string
	 */
	this._id      = options.id;
	/**
	 * @protected
	 * @type string|gc.gis.widget.GCWidget
	 */
	this._target  = options.target;
	/**
	 * @protected
	 * @type {string}
     */
	this._className = options.className;
};
gc.gis.control.GCAbstractMapControl.prototype = Object.create( gc.gis.GCWrappable.prototype );

/**
 * Initialisiert das Control.
 *
 * @public
 * @abtract
 * @method
 */
gc.gis.control.GCAbstractMapControl.prototype.init = gc.gis.abstractMethod;

/**
 * Gibt das Element dieses Controls zurück.
 *
 * @public
 * @return {jQuery} jQuery-Element dieses Controls
 */
gc.gis.control.GCAbstractMapControl.prototype.getElement = function()
{
	return this._element;
};

